<template>
<div class="column is-12">
            <!----------- tags ---------------------------------->
            <div class="field">
              <label class="label">{{ elLabel }}</label>
              <div class="control">
                <div class="field is-grouped is-grouped-multiline">
                  <div v-for="(i, index) in allTags" :key="index" class="control">
                    <div class="tags has-addons">
                      <span @click="$emit('wasUpdated', i)" class="tag is-rounded is-medium cursor" :class="[ {'is-primary' : (data.indexOf(i) !== -1)}, 'tag_' + i ]"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
</div>
</template>

<script>
export default {
  // inject: ['$validator'],
  props: ['data', 'elLabel', 'allTags'],
  data () {
    return {
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Tags.vue